import './ChatBox.scss';
import ChatMessage from '../ChatMessages/ChatMessages';
import ChatInput from '../ChatInput/ChatInput';

interface propsTypes {
  handleSendMessage:(text: string) => void;
  chatMessages:ChatMessages[];
  currentUserName:string | undefined;
}

interface ChatMessages {
  id: any;
  message: string;
  userName: string;
  isReadBy: [
      {
          "userName": string,
          "userId": string,
          "attenteeId":string
      }
  ],
}

const ChatBox = ({ handleSendMessage, chatMessages, currentUserName}: propsTypes) => {


  return (
    <div className="chat-box">
      <div className="chat-header">
        Chats
      </div>
      <div className="chat-messages">
        {
          chatMessages && chatMessages.map((chats, index) => {
            return <ChatMessage
              message={chats.message}
              userName={chats.userName}
              key={index}
              isCurrentUser={currentUserName === chats.userName}
            />
          })
        }
      </div>
      <ChatInput onSend={handleSendMessage} />
    </div>
  );
}

export default ChatBox;
